const menus = [
    {
        name: '商家首页',
        to: '/dashboard'
    },
    {
        name: '采购商品',
        icon: 'https://commimg.pddpic.com/mms_static/2019-11-15/e28bf79a-91ca-4101-94d7-c598ffd0f523.png',
        children: [
            {
                name: '我要采购',
                to: '/purchase/categories',
                require_permission: 'products.purchase'
            },
            {
                name: '商品收藏夹',
                to: '/purchase/favorites',
                require_permission: 'products.purchase'
            }
        ]
    },
    {
        name: '订单管理',
        icon: 'https://commimg.pddpic.com/mms_static/2019-11-15/24c8b43e-37b1-4967-bdec-d6aabfaf3935.png',
        children: [
            {
                name: '我的订单',
                to: '/orders',
                require_permission: 'orders'
            },
            {
                name: '批量订单',
                to: '/batch-orders',
                require_permission: 'orders'
            },
            {
                name: '售后记录',
                to: '/order-complaints',
                require_permission: 'order_complaints'
            }
        ]
    },
    {
        name: '财务管理',
        icon: 'https://commimg.pddpic.com/mms_static/2019-11-15/b61dd2ec-e9d8-41eb-971a-35957520e6ca.png',
        children: [
            {
                name: '账户充值',
                to: '/charge-balance',
                require_permission: 'finance.charge_balance'
            },
            {
                name: '财务记录',
                to: '/balance-records',
                require_permission: 'finance.balance_records'
            }
        ]
    },
    {
        name: '账户管理',
        icon: 'https://commimg.pddpic.com/mms_static/2019-11-15/a0b6afda-b18c-4bf9-b4c3-f48a3396ff36.png',
        children: [
            {
                name: '安全设置',
                to: '/security/login_psw'
            },
            {
                name: '接口密钥',
                to: '/security/api_key'
            },
            {
                name: '关联商城',
                to: '/settings/renren'
            },
        ]
    }
];

export default menus;
